import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';

const GreenPrimaryButton = styled(Button)(({ theme }) => ({
    color: '#FFF',
    height: '3.12rem',
    padding: '1rem',
    backgroundColor: '#01A32D',
    borderRadius: '0.5rem',
    '&:hover': {
    backgroundColor: '#01A32D',
    }
}));

export default GreenPrimaryButton;